import { NavLink, Outlet } from 'react-router';
import { CONFIG_NAV, visibleFor } from '@/components/layout/nav';
import { PageHeader } from '@/components/PageHeader';
import { useCurrentLocal } from '@/lib/local-context';
import { cn } from '@/lib/utils';

/** `/l/:localId/configuracion/*`: sub-navegación (chips scrolleables en mobile, columna en desktop). */
export function ConfigLayout() {
  const local = useCurrentLocal();
  const items = CONFIG_NAV.filter(visibleFor(local.role));

  return (
    <div>
      <PageHeader title="Configuración" description={local.name} />
      <div className="gap-8 md:flex">
        <nav className="-mx-4 mb-5 flex gap-2 overflow-x-auto px-4 pb-1 md:mx-0 md:mb-0 md:w-52 md:shrink-0 md:flex-col md:overflow-visible md:px-0">
          {items.map((item) => (
            <NavLink
              key={item.to}
              to={`/l/${local.id}/${item.to}`}
              className={({ isActive }) =>
                cn(
                  'flex shrink-0 items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-accent md:rounded-md md:border-0',
                  isActive && 'border-primary bg-accent text-accent-foreground',
                )
              }
            >
              <item.icon className="size-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
